import * as React from "react";
import * as BS from "react-bootstrap";
import { Link } from "react-router-dom";
import { Paths } from "../../../constants";

interface OwnProps {
    abstractsEnabled: boolean;
    eventId: number;
    view: "Calendar";
}

export const EventViewSwitcher: React.SFC<OwnProps> = (props) => {
    return <BS.DropdownButton id="views" title={props.view}>
        {
            props.abstractsEnabled
            ? <>
                <li><Link role="menuitem" to={Paths.AdminAbstractList(props.eventId)}>Abstracts</Link></li>
                <li><Link role="menuitem" to={Paths.AdminAbstractDisclosures(props.eventId)}>Disclosures</Link></li>
                <li><Link role="menuitem" to={Paths.AdminAbstractInvitationEmails(props.eventId)}>Acceptance emails</Link></li>
            </>
            : null
        }
        <li className={props.view === "Calendar" ? "active" : ""}><Link role="menuitem" to={Paths.AdminEventCalendarEdit(props.eventId)}>Calendar</Link></li>
    </BS.DropdownButton>;
};



// WEBPACK FOOTER //
// ./src/containers/adminEvent/components/EventViewSwitcher.tsx